import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICallPurpose, ICallPurposeState } from "./callpurposeModel";
import {
  CallPurposeActiveInactive,
  createCallPurpose,
  deleteCallPurpose,
  getAllActiveCallPurpose,
  getAllCallPurpose,
  getCallPurposeByID,
  updateCallPurpose,
} from "./services/callpurpose.service";

const initialState: ICallPurposeState = {
  loading: false,
  formLoading: false,
  error: "",
  CallPurposeList: [],
  CallPurposeID: null,
  CallPurposeDetail: {
    call_purpose: "",
    isactive: 1,
  },
};

const callpurposeSlice = createSlice({
  name: "callofpurpose",
  initialState,
  reducers: {
    clearCallPurposeDetails: (state) => {
      state.CallPurposeDetail = initialState.CallPurposeDetail;
    },
    setCallPurposeID: (state, action) => {
      state.CallPurposeID = action.payload;
    },
    clearCallPurposeID: (state) => {
      state.CallPurposeID = initialState.CallPurposeID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllCallPurpose.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllCallPurpose.fulfilled,
      (state, action: PayloadAction<ICallPurpose[]>) => {
        state.loading = false;
        state.CallPurposeList = action.payload || [];
      }
    );
    builder.addCase(getAllCallPurpose.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CallPurposeList = [];
    });
    builder.addCase(getAllActiveCallPurpose.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveCallPurpose.fulfilled,
      (state, action: PayloadAction<ICallPurpose[]>) => {
        state.loading = false;
        state.CallPurposeList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveCallPurpose.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CallPurposeList = [];
    });
    builder.addCase(createCallPurpose.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createCallPurpose.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createCallPurpose.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateCallPurpose.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateCallPurpose.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateCallPurpose.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteCallPurpose.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteCallPurpose.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteCallPurpose.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(CallPurposeActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(CallPurposeActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(CallPurposeActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getCallPurposeByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getCallPurposeByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.CallPurposeDetail = action.payload;
    });
    builder.addCase(getCallPurposeByID.rejected, (state, action) => {
      state.formLoading = false;
      state.CallPurposeDetail = initialState.CallPurposeDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearCallPurposeDetails, setCallPurposeID, clearCallPurposeID } =
  callpurposeSlice.actions;
export default callpurposeSlice.reducer;
